import styled, { css } from 'styled-components'

interface IMedicationInUse {
  medicationUse?: boolean
}

export const Container = styled.div`
  position: relative;
  width: 100%;

  display: grid;
  grid-template-columns: minmax(100px, 178px) minmax(calc(91px * 4), 1.5fr) minmax(107px, 0.5fr);
  gap: 0.5rem;
`

export const MeasurementsGroup = styled.div`
  position: relative;
  height: 100%;
  width: 100%;

  display: grid;
  direction: rtl;
  grid-template-columns: repeat(4, minmax(91px, 1fr));
  border-radius: 4px;
  overflow: hidden;
`

export const EmptyMeasurement = styled.div`
  position: relative;
  width: 100%;
  min-height: 48px;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.theme.colors.colorf3f5f9};

  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: ${props => props.theme.colors.color6b7786};
`
export const ItemContainer = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  flex-direction: column;
`

export const CellContainer = styled.div<IMedicationInUse>`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 40px;
  background-color: ${props =>
    props.medicationUse === undefined
      ? props.theme.colors.colorf3f5f9
      : props.medicationUse === true
        ? props.theme.colors.colorFFE9E9
        : props.theme.colors.colore6f4e7};
  justify-content: center;
  align-items: center;
  padding: 4px;
`

export const MedicationUseTitle = styled.p`
  display: flex;
  flex: 1;
  font-size: 10px;
  color: ${props => props.theme.colors.color545e6c};
  margin-bottom: 5px;
`

export const MedicationUseValue = styled.p<IMedicationInUse>`
  color: ${props =>
    props.medicationUse === undefined ? props.theme.colors.color6b7786 : props.theme.colors.color122d52};
  font-weight: 600;
`

const normalStyle = css`
  background-color: ${props => props.theme.colors.colore6f4e7};
`

const alteredStyle = css`
  background-color: ${props => props.theme.colors.colorFFE9E9};
`

const resultedStyle = css`
  background: ${({ theme }) => theme.zds.colors.neutral1000};
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
`

export const MeasurementContainer = styled.div<{ status: 'normal' | 'altered' | 'result' }>`
  position: relative;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ status }) => {
    switch (status) {
      case 'normal':
        return normalStyle
      case 'altered':
        return alteredStyle
      case 'result':
        return resultedStyle
    }
  }}
`

export const Value = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  color: ${props => props.theme.colors.color2d3139};
`
